import React from 'react';
import logo from '../logo.jpg'
const LoadingPage = () => (
  <div className="auth-page-wrapper justify-content-center">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-6 text-white text-center text-md-start">
           <div className="d-flex align-items-center mb-4 justify-content-center justify-content-md-start">
         <div className="logo-placeholder me-3">
                   <img src={logo} className='rounded-circle' alt="IEEE Logo" width="75" />
                 </div>  
            <h4 className="fw-bold m-0">IEEE Study Groups</h4>
          </div>
          <h1 className="display-3 fw-bold">Loading ...</h1>
          <p className="lead opacity-75">We are still loading the app, please wait to ensure the best experience</p>
        </div>
        <div className="col-md-6 text-center">
           <div className=" d-inline-block p-5 rounded-5">
              <img src={logo} alt="IEEE MUSB"  style={{width: '100%'}} />
           </div>
        </div>
      </div>
    </div>
  </div>
);

export default LoadingPage;